import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import classnames from "classnames";

const ManageModal = ({
  title,
  types,
  selectedType,
  file,
  videoSrc,
  onChange,
  onSubmit,
  show,
  toggle,
  saving
}) => {
  const typeInputClass = classnames("form-control", {
    "is-invalid": !selectedType.isValid
  });
  const titleInputClass = classnames("form-control", {
    "is-invalid": !title.isValid
  });
  const fileInputClass = classnames("form-control", {
    "is-invalid": !file.isValid
  });
  const videoSrcInputClass = classnames("form-control", {
    "is-invalid": !videoSrc.isValid
  });
  const btnDisabled = saving ? 'disabled' : '';
  const saveIcon = classnames('fa', { 'fa-check-circle': !saving},
    { 'fa-spin': saving }, { 'fa-spinner': saving });
  const saveText = saving ? 'Saving...' : 'Save';
  const acceptedFileTypes = selectedType.value == 1 ? '.pdf' : '.jpg, .tiff, .png';
  const videoSrcRowClass = classnames('form-row', { 'invisible': selectedType.value != 3 });
  const fileRowClass = classnames('form-row', { 'invisible': selectedType.value == 3 });

  return (
    <form onSubmit={onSubmit} noValidate>
      <Modal isOpen={show} toggle={toggle}>
        <ModalHeader toggle={toggle}>Manage Artifact</ModalHeader>
        <ModalBody>
          <div className="form-row">
            <label htmlFor="selectedType">Type</label>
            <select
              name="selectedType"
              className={typeInputClass}
              onChange={onChange}
              value={selectedType.value}
              autoFocus
            >
              <option value="" />
              {types.map(t => (
                <option key={t.typ_id} value={t.typ_id}>
                  {t.typ_name}
                </option>
              ))}
            </select>
            <div className="invalid-feedback">{selectedType.message}</div>
          </div>

          <div className="form-row">
            <label htmlFor="Title">Title</label>
            <input
              type="text"
              className={titleInputClass}
              name="title"
              value={title.value}
              onChange={onChange}
              required
            />
            <div className="invalid-feedback">{title.message}</div>
          </div>

          <div className={fileRowClass}>
            <p style={{ paddingTop: 20 }}>
            <input
              type="file"
              name="file"
              className={fileInputClass}
              onChange={onChange}
              accept={acceptedFileTypes}
            />
            </p>
            <div className="invalid-feedback">{file.message}</div>
          </div>

          <div className={videoSrcRowClass}>
            <label htmlFor="videoSrc">Source URL</label>
            <input
              type="text"
              className={videoSrcInputClass}
              name="videoSrc"
              onChange={onChange}
              value={videoSrc.value}
            />
            <div className="invalid-feedback">{videoSrc.message}</div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-danger" onClick={toggle} disabled={btnDisabled}>
            <i className="fa fa-times-circle" /> Cancel
          </button>

          <button type="submit" className="btn btn-success" onClick={onSubmit} disabled={btnDisabled}>
            <i className={saveIcon} /> {saveText}
          </button>
        </ModalFooter>
      </Modal>
    </form>
  );
};

export default ManageModal;



// WEBPACK FOOTER //
// ./src/pages/Artifacts/ManageModal.jsx